<template>
    <v-container fluid class="mb-12 mb-lg-0">
        <v-row justify="center">
            <v-col md="12">
                <v-card width="100%">
                    <v-card-title class="d-block text-center font-weight-bold primary warning--text py-2"
                                  style="word-break: normal">CORRECCIONES PENDIENTES
                    </v-card-title>
                    <v-btn bottom color="warning primary--text" dark depressed fab absolute right small @click="getCorrections(1)">
                        <v-icon>mdi-sync</v-icon>
                    </v-btn>
                </v-card>
            </v-col>
        </v-row>
        <v-row justify="center">
            <v-col md="12">
                <v-card>
                    <v-card-title>
                        <v-text-field v-model="search" append-icon="mdi-magnify" label="Buscar" single-line hide-details/>
                    </v-card-title>
                    <v-data-table :headers="headers" :items="desserts" :search="search" :loading="loading"
                                  :no-data-text="noDataText" :footer-props="footerProps" class="mb-12 mb-lg-0">
                        <template v-slot:item.id="{ item }">
                            <strong>{{ item.id }}</strong>
                        </template>
                        <template v-slot:item.name="{ item }">
                            <span style="text-transform: capitalize">{{ (item.name).toLowerCase() }}</span>
                        </template>
                        <template v-slot:item.action="{ item }">
                            <strong>
                                <v-btn color="success" small depressed dark @click="correctionT(item.transfer_id)">
                                    <v-icon>mdi-square-edit-outline</v-icon>
                                </v-btn>
                            </strong>
                        </template>
                    </v-data-table>
                </v-card>
                <v-dialog v-model="ct" scrollable persistent max-width="1000px">
                    <transfer v-on:close-transfer="closeT" :id="id" @success="getCorrections"/>
                </v-dialog>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import axios from 'axios';
    import Transfer from "../../correction/Transfer";

    export default {
        name: "TCorrections",
        components: { Transfer },
        props: [ 'user' ],
        data: () => ({
            search: '',
            headers: [
                { text: 'ID', value: 'id', align: 'right' },
                { text: 'Código', value: 'code', align: 'right', sortable: false },
                { text: 'Cliente', value: 'name', align: 'left', sortable: false },
                { text: 'Error', value: 'error', align: 'left', sortable: false },
                { text: 'Descripción', value: 'message', align: 'left', sortable: false },
                { text: 'Cant.', value: 'qty', align: 'right', sortable: false },
                { text: 'Fecha', value: 'updated_at', align: 'right', sortable: false },
                { text: 'Acción', value: 'action', filterable: false, sortable: false }
            ],
            desserts: [],
            loading: true,
            noDataText: 'No tienes correcciones pendientes',
            footerProps: {
                itemsPerPageOptions: [25, 50, 100, 250, -1]
            },
            ct: false,
            id: null
        }),
        created () {
            this.getCorrections();
        },
        methods: {
            getCorrections(v) {
                this.loading = true;
                if (v === 1) { this.desserts = [];}
                axios.get('/api/payer/corrections').then((res) => {
                    this.desserts = res.data.items;
                }).catch(err => {
                    this.handleErrors(err.response.data.errors);
                }).then(() => {
                    this.loading = false;
                });
            },
            correctionT(id) {
                this.id = id;
                this.ct = true;
            },
            closeT() {
                this.ct = false;
                this.id = null;
            }
        }
    }
</script>

<style scoped>

</style>
